module.exports = __webpack_public_path__ + "media/images/icons/arrow-thick-left-14e6bc1a4ec4c86edec2b69646c448b5.svg";